import styled from "styled-components";

export const ImgSave = styled.img`
  width: 20px;
  height: 20px;
`;
